/**
 * Created By Elia Rohana on 7/8/19
 */
import EventBus from 'diagram-js/lib/core/EventBus';
import { subProcessType } from '@ispm-shared/modules/bpmn/diagram-element-terms';

export class SubprocessChildrenAddBehavior {

    constructor(private eventBus: EventBus) {
        eventBus.on([
            'shape.add',
            'shape.added',
            'shape.changed',
            'connection.add',
            'connection.added',
            'connection.changed'
        ], 100000, this.interceptChildrenEvents);

        eventBus.on([
            'shape.added',
            'connection.added',
        ], 100000, this.interceptUnRenderedElementEvents);
    }

    interceptChildrenEvents(event) {
        if (event.element.parent && event.element.parent.type === subProcessType ) {
            return true;
        }
    }

    interceptUnRenderedElementEvents(event) {
        if (!event.gfx) {
            return true;
        }
    }
}
